import PropTypes from "prop-types";
import { TAB_NAMES } from "./product-info";

export default function HeadTabs({ tabSelected, setTabSelected }) {
  return (
    <>
      <h4 id="product-details" className="h4">
        Product Info
      </h4>
      <div className="pdp-product-info__tabs">
        {Object.values(TAB_NAMES).map((val, index) => {
          return (
            // the width is being set in pdp-content.scss which is dependent on the
            // bolded width of text, if text changes then change the width in css too
            <button
              key={index}
              className={`${val === tabSelected ? "selected-tab" : ""} tab${index}`}
              onClick={() => {
                setTabSelected(val);
              }}>
              {val}
            </button>
          );
        })}
      </div>
    </>
  );
}

HeadTabs.propTypes = {
  tabSelected: PropTypes.string,
  setTabSelected: PropTypes.func,
};
